






















import { Component, Vue, Prop } from "vue-property-decorator";
import { sanitizePlainText } from "@/utils/sanitize";

@Component
export default class InfoTextArea extends Vue {
  @Prop() label!: string;
  @Prop() text!: string;
  @Prop({ default: false }) long!: boolean;

  private sanitize = sanitizePlainText;
}
